import { requestLoginOtpService, verifyLoginOtpService } from '@http/loginService'
import { call, takeEvery, put } from 'redux-saga/effects'
import { login, LoginAction, loginFailed, loginSuccess, otpRequested, verifyOtp, VerifyOtpAction } from './loginSlice'

const errorMessage = (error: any): string =>
  error?.response?.data?.message || error?.message || 'Error de autenticación'

export function* requestOtpHttp(action: LoginAction) {
  const { username, password } = action.payload
  try {
    const response = yield call(requestLoginOtpService, username, password)
    if ('user' in response) {
      yield put(loginSuccess(response))
      return
    }
    const now = Date.now()
    yield put(
      otpRequested({
        ...response,
        email: username.trim().toLowerCase(),
        expiresAt: now + response.expiresIn * 1000,
        resendAt: now + response.resendAfter * 1000
      })
    )
  } catch (error) {
    yield put(loginFailed(errorMessage(error)))
  }
}

export function* verifyOtpHttp(action: VerifyOtpAction) {
  try {
    const response = yield call(verifyLoginOtpService, action.payload.challengeId, action.payload.otp)
    yield put(loginSuccess(response))
  } catch (error) {
    yield put(loginFailed(errorMessage(error)))
  }
}

export default function* loginSaga() {
  yield takeEvery(login.type, requestOtpHttp)
  yield takeEvery(verifyOtp.type, verifyOtpHttp)
}
